<app-select2-badges [formControlName]="question.key"
                    [ngClass]="{'is-invalid': !isValid}"
                    [id]="question.key"
                    [objects]="question.options"
                    [multiple]="question.multiple"
                    [placeholder]="question.placeholder"
                    [required]="question.required">
</app-select2-badges>
